import 'react-native-gesture-handler'
import { App } from 'app'

export default App
